// extracted by mini-css-extract-plugin
export var contentBody = "_a8-9";
export var headerImage = "_a8-2";
export var imageButton = "_a8-7";
export var imageButtonIcon = "_a8-8";
export var imageHeader = "_a8-4";
export var imageHeaderText = "_a8-5";
export var imageOverlay = "_a8-3";
export var imageTitle = "_a8-6";
export var imageWrapper = "_a8-1";
export var taskList = "_a8-a";
export var widget = "_a8-0";